import { useState } from "react"
import { getOrderCacheDetailById, postOrderCacheDetail, patchOrderCacheDetail ,getOrderCacheDetailPanel } from "../../services/OrderCacheDetailServices"
import { PedidosDetalleFormContext } from "./PedidosDetalleContext"
import { getArticuloById } from "../../services/ArticulosServices";
import { useNavigate } from 'react-router-dom';
//import { Color } from '../../routes/RoutesConstants'

export const PedidosDetalleFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();

    const getPedidoDetalleByIdData = async (id) => {
        let res = await getOrderCacheDetailById(id)
        if (res) setReport(res)
        return res
    }

    const postPedidoDetalleData = async (body) => {
        const res = await postOrderCacheDetail(body)
        return res
    }

    const patchPedidoDetalleData = async (id, body) => {
        const res = await patchOrderCacheDetail(id, body);
        return res;
    };

    const getBusquedaArticuloByIdData = async (id) => {
        try {
            let res = await getArticuloById(id);
            return res;
        } catch (error) {
            console.error("Error obteniendo artículo por ID:", error);
            return null;
        }
    };

    const getPedidosDetallePanelData = async (searchOca, searchArt, page, perPage) => {
        let res = await getOrderCacheDetailPanel(searchOca, searchArt, page, perPage)
        return res;
    };
    return <PedidosDetalleFormContext.Provider value={{
        report,
        getPedidoDetalleByIdData,
        postPedidoDetalleData,
        patchPedidoDetalleData,
        getPedidosDetallePanelData,
        getBusquedaArticuloByIdData,
    }} >
        {children}
    </PedidosDetalleFormContext.Provider>
}